import { render, staticRenderFns } from "./DatingMannerPage.vue?vue&type=template&id=d6f40508&scoped=true"
import script from "./DatingMannerPage.vue?vue&type=script&lang=js"
export * from "./DatingMannerPage.vue?vue&type=script&lang=js"
import style0 from "./DatingMannerPage.vue?vue&type=style&index=0&id=d6f40508&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f40508",
  null
  
)

export default component.exports